__turbopack_context__.v({
  "option": "LanguageSwitcher-module__L1VFkq__option",
  "optionsTrayAnchor": "LanguageSwitcher-module__L1VFkq__optionsTrayAnchor",
  "optionsTrayFan": "LanguageSwitcher-module__L1VFkq__optionsTrayFan",
  "root": "LanguageSwitcher-module__L1VFkq__root",
  "trigger": "LanguageSwitcher-module__L1VFkq__trigger",
});
